import React, { Component } from "react";
//import request from "superagent";
import { withTranslation } from "react-multi-lang";
import { css } from "@emotion/core";
import PuffLoader from "react-spinners/PuffLoader";
import $ from "jquery";
import pako, { gzip } from 'pako';
// const axios = require('axios');
import axios from "axios";

const override = css`
    position: fixed;
    z-index: 999;
    height: 2em;
    width: 2em;
    overflow: visible;
    margin: auto;
    top: 50%;
    left: 50%;
    bottom: 0;
    right: 0;
    margin-top: -50px;
    margin-left: -50px;

    :before {
        content: '';
        display: block;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0,0,0,0.3);
    }
`;


class Service extends Component {
    _isMounted = false;
    constructor(props) {
        super(props);
        this.state = {
            IsLoader: false,
            Tourl: this.props.Tourl,
            MethodType: this.props.MethodType

        }

    }

    closeModel() {
        this.setState({ IsLoader: false });
    }

    async UNSAFE_componentWillReceiveProps(nextProps) {

        if (nextProps !== undefined && nextProps.Tourl !== undefined && nextProps.Tourl !== "") {
            if (nextProps.Needprogress !== undefined && nextProps.Needprogress === false) {
                if (nextProps.MethodType === "POST") {
                    // request
                    //     .post(nextProps.Tourl)
                    //     .send(await gzip(JSON.stringify(nextProps.Headerobject)))
                    //     .set({ 'X-TenantID': "MAIN", 'Authorization': $.session.get("TenantToken"), Accept: 'application/json' ,
                    //         "Content-Type": 'application/json',
                    //         "Content-Encoding": 'gzip'})
                    //     .then((res) => {
                    //         if (this._isMounted) {
                    //             nextProps.onSuccess(JSON.parse(res.text));
                    //         }
                    //     })
                    //     .catch((error) => {
                    //         nextProps.onFailure(error);
                    //     });

                    axios.post(nextProps.Tourl, await gzip(JSON.stringify(nextProps.Headerobject)), {
                        headers: {
                            'X-TenantID': "MAIN", 'Authorization': $.session.get("TenantToken"), Accept: 'application/json',
                            "Content-Type": 'application/json',
                            "Content-Encoding": 'gzip'
                        }
                    }).then(response => {
                        if (this._isMounted) {
                            nextProps.onSuccess((response.data));
                        }
                    }).catch((error) => {
                        nextProps.onFailure(error);
                    });
                }
                else {
                    // request
                    //     .get(nextProps.Tourl)
                    //     .send({})
                    //     // .set({ 'X-TenantID': "MAIN", Accept: 'application/json' })
                    //     .set({ 'X-TenantID': "MAIN", 'Authorization': $.session.get("TenantToken"), Accept: 'application/json',
                    //         "Content-Type": 'application/json',
                    //         "Content-Encoding": 'gzip' })
                    //     .then((res) => {
                    //         if (this._isMounted) {
                    //             nextProps.onSuccess(JSON.parse(res.text));
                    //         }
                    //     })
                    //     .catch((error) => {
                    //         nextProps.onFailure(error);
                    //     });


                    axios.get((nextProps.Tourl), {
                        headers: {
                            'X-TenantID': "MAIN", 'Authorization': $.session.get("TenantToken"), Accept: 'application/json',
                            "Content-Type": 'application/json',
                            "Content-Encoding": 'gzip'
                        }
                    }).then(response => {
                        if (this._isMounted) {
                            nextProps.onSuccess((response.data));
                        }
                    }).catch((error) => {
                        nextProps.onFailure(error);
                    });
                }
            }
            else {
                this.setState({ IsLoader: true });
                if (nextProps.MethodType === "POST") {
                    // request
                    //     .post(nextProps.Tourl)
                    //     .send(await gzip(JSON.stringify(nextProps.Headerobject)))
                    //     // .set({ 'X-TenantID': "MAIN", Accept: 'application/json' })
                    //     .set({ 'X-TenantID': "MAIN", 'Authorization': $.session.get("TenantToken"), Accept: 'application/json',
                    //         "Content-Type": 'application/json',
                    //         "Content-Encoding": 'gzip' })
                    //     .then((res) => {
                    //         if (this._isMounted) {
                    //             setTimeout(this.closeModel.bind(this), 10);
                    //             nextProps.onSuccess(JSON.parse(res.text));
                    //         }
                    //     })
                    //     .catch((error) => {
                    //         setTimeout(this.closeModel.bind(this), 10);
                    //         nextProps.onFailure(error);
                    //     });


                    axios.post(nextProps.Tourl, await gzip(JSON.stringify(nextProps.Headerobject)), {
                        headers: {
                            'X-TenantID': "MAIN", 'Authorization': $.session.get("TenantToken"), Accept: 'application/json',
                            "Content-Type": 'application/json',
                            "Content-Encoding": 'gzip'
                        },
                        responseType: 'arraybuffer'
                    }).then(response => {
                        if (this._isMounted) {
                            const compressedData = new Uint8Array(response.data);
                            const decompressedData = pako.inflate(compressedData, { to: 'string' });
                            setTimeout(this.closeModel.bind(this), 10);
                            nextProps.onSuccess(JSON.parse(decompressedData));
                        }
                    }).catch((error) => {
                        setTimeout(this.closeModel.bind(this), 10);
                        nextProps.onFailure(error);
                    });

                }
                else {
                    // request.set({ 'X-TenantID': 'ELN1' });
                    // request
                    //     .get(nextProps.Tourl)
                    //     .send({})
                    //     // .set({ 'X-TenantID': "MAIN", Accept: 'application/json' })
                    //     .set({ 'X-TenantID': "MAIN", 'Authorization': $.session.get("TenantToken"), Accept: 'application/json',
                    //         "Content-Type": 'application/json',
                    //         "Content-Encoding": 'gzip' })
                    //     .then((res) => {
                    //         if (this._isMounted) {
                    //             setTimeout(this.closeModel.bind(this), 10);
                    //             nextProps.onSuccess(JSON.parse(res.text));
                    //         }
                    //     })
                    //     .catch((error) => {
                    //         setTimeout(this.closeModel.bind(this), 10);
                    //         nextProps.onFailure(error);
                    //     });

                    axios.get(nextProps.Tourl, {
                        headers: {
                            'X-TenantID': "MAIN", 'Authorization': $.session.get("TenantToken"), Accept: 'application/json',
                            "Content-Type": 'application/json',
                            "Content-Encoding": 'gzip'
                        },
                        responseType: 'arraybuffer'
                    }).then(response => {
                        if (this._isMounted) {
                            const compressedData = new Uint8Array(response.data);
                            const decompressedData = pako.inflate(compressedData, { to: 'string' });
                            setTimeout(this.closeModel.bind(this), 10);
                            nextProps.onSuccess(JSON.parse(decompressedData));
                        }
                    }).catch((error) => {
                        setTimeout(this.closeModel.bind(this), 10);
                        nextProps.onFailure(error);
                    });

                }
            }
            this.props.onReseturl();
        }
    }

    componentDidMount() {
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {

        let display = "clsDisplaynone";
        if (this.state.IsLoader) {
            display = "clsdisplayblock";
        }
        return (<div className={"cls-loader " + display}>
            {/* <div className={"row justify-content-center align-items-center "}>
                <Loader type="Puff" color="#00BFFF" width={180} height={180} />
            </div>
            <div className="clear"></div> */}
            <PuffLoader
                css={override}
                size={100}
                color={"#123abc"}
            />
        </div>)
    }
}
export default withTranslation(Service);